<template>
	<div>
		<div class="title-with-right-button-area">
			<div class="title" ref="title">
				<h1>{{ reportTitle }}</h1>
			</div>
			<div class="right-btn mobile-hide" :class="{ jbFixed: this.jbScroll }">
				<button type="button" class="lineBtn back" :class="{ writingBtnFixed: this.jbScroll }" @click.prevent.stop="goDetail()">
					뒤로가기
				</button>
				<!-- <button
					type="button"
					class="lineBtn back"
					:class="{ writingBtnFixed: this.jbScroll }"
					@click.prevent.stop="doSubmit('WRITING')"
					v-if="!isCompany && !reportComplete"
				>
					임시저장
				</button> -->
				<button
					type="button"
					class="greenBtn"
					:class="{ saveBtnFixed: this.jbScroll }"
					@click.prevent.stop="doSubmit('DONE')"
					v-if="!isCompany && !reportComplete"
				>
					제출
				</button>
			</div>
		</div>
		<div class="basic-container">
			<div class="programe-report-area">
				<form name="reportForm" id="reportForm" method="post">
					<section>
						<h4 class="memo-title">관리자메모</h4>
						<div class="memo-box">
							<pre>{{ adminMemo }}</pre>
						</div>
					</section>
				</form>
				<MainMonthlyReportList :matchSeqNo="matchSeqNo" :reportYm="reportYm" :reportMetaObjList="reportMetaObjList"></MainMonthlyReportList>
			</div>
		</div>
	</div>
</template>

<script>
import eventBus from '@/plugins/event-bus';
import CONST from '@/constants';
import MainMonthlyReportList from '@/components/mybusiness/Main-Monthly-Report-List';

export default {
	title: '보고서',
	name: 'Mybusiness-Online-Report-One',
	components: { MainMonthlyReportList },
	props: ['matchSeqNo', 'reportYm'],
	data: function() {
		return {
			loginMember: null,
			programCode: '',
			apiData: null,
			reportState: 'NONE',
			reportSeqNo: 0,
			reportTitle: '월별보고서',
			adminMemo: '',
			reportMetaList: [],
			reportMetaObjList: [],
			dataLodingFlag: false,
			jbScroll: false,
		};
	},
	methods: {
		onScroll: function() {
			var jbOffset = this.$refs.title.offsetHeight;
			// this.scrollY = window.scrollY;
			this.scrollY = window.pageYOffset;

			if (this.scrollY > jbOffset) {
				this.jbScroll = true;
			} else {
				this.jbScroll = false;
			}
		},
		setReportTitle: function() {
			if (this.reportYm) this.reportTitle = '월별보고서(' + this.reportYm + ')';
		},
		loadReportData: function() {
			let formData = new FormData();
			formData.append('matchSeqNo', this.matchSeqNo);
			formData.append('reportYm', this.reportYm);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getReportInfo.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						if (res.data.data !== null) {
							this.apiData = res.data.data;
							this.reportState = this.apiData.reportState;
							this.reportSeqNo = this.apiData.seqNo;
							this.adminMemo = this.apiData.adminMemo;
							this.$nextTick(() => {
								this.loadMetaData();
							});
						} else {
							// this.resetReportForm();
						}
					} else {
						window.alert(res.data.resultMsg);
						this.$device.pushView('/mybusiness/detail/' + this.matchSeqNo);
					}
				})
				.catch(e => console.error(e));
		},
		loadMetaData: function() {
			let formData = new FormData();
			formData.append('reportSeqNo', this.reportSeqNo);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getReportMeta2.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						if (res.data.data !== null) {
							this.$nextTick(() => {
								this.createLoadMetaData(res.data);
							});
						} else {
							// this.resetReportForm();
						}
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		createLoadMetaData: function(dt) {
			if (dt.resultCode === 0) {
				this.reportMetaList = dt.data;
				this.reportMetaList.forEach(arr => {
					let obj = {
						REPORT_SEQ_NO: '',
						REPORT_TYPE: '',
						REPORT_TYPE_NM: '',
						REPORT_TITLE: '',
						REPORT_CONTENTS: '',
						REPORT_WRITER: '',
						REPORT_REG_DATE: '',
						REPORT_FILE: [],
					};
					arr.forEach(item => {
						if (item.contentType.indexOf('REPORT_TYPE') > -1) {
							obj.REPORT_TYPE = item.contentBody;
							obj.REPORT_SEQ_NO = item.reportSeqNo;
							obj.REPORT_REG_DATE = this.$moment(item.regDate).format('YYYY-MM-DD');
							switch (item.reportType) {
								case 'I':
									obj.REPORT_TYPE_NM = '보고서';
									break;
								case 'M':
									obj.REPORT_TYPE_NM = '수정보고서';
									break;
								case 'F':
									obj.REPORT_TYPE_NM = '정산증빙자료';
									break;
								default:
									obj.REPORT_TYPE_NM = '보고서';
									break;
							}
						} else if (item.contentType.indexOf('REPORT_TITLE') > -1) {
							obj.REPORT_TITLE = item.contentBody;
						} else if (item.contentType.indexOf('REPORT_CONTENTS') > -1) {
							obj.REPORT_CONTENTS = item.contentBody;
						} else if (item.contentType.indexOf('REPORT_WRITER') > -1) {
							obj.REPORT_WRITER = item.contentBody;
						} else if (item.contentType.indexOf('REPORT_FILE') > -1) {
							obj.REPORT_FILE.push(item.contentBody);
						}
					});
					this.reportMetaObjList.push(obj);
				});

				this.dataLodingFlag = true;
			} else {
				window.alert(dt.resultMsg);
			}
		},
		goDetail: function() {
			this.$device.pushView('/mybusiness/detail/' + this.matchSeqNo);
		},
		doSubmit: function(saveType) {
			let formData = new FormData();

			formData.append('saveType', saveType);
			formData.append('matchSeqNo', this.matchSeqNo);
			formData.append('reportYm', this.reportYm);
			formData.append('reportType', 'MONTHLY');

			if (!this.dataLodingFlag) {
				alert('데이터 로딩중입니다.');
				return false;
			}

			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/reportSubmit2.do', formData, {})
				.then(res => {
					if (res.data.resultCode === 0) {
						alert('저장되었습니다.');
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
	},
	computed: {
		isCompany: function() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
		reportComplete: function() {
			return this.reportState === 'CONFIRM';
		},
	},
	created() {
		this.setReportTitle();

		window.addEventListener('scroll', this.onScroll);
	},
	mounted() {
		eventBus.$emit(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		this.$store.commit('setMonthlyReportNo', { matchSeqNo: this.matchSeqNo, reportYm: this.reportYm });
		this.loadReportData();
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll);
	},
};
</script>

<style scoped></style>
